import type { AttributesStatus, AttributeTaskStage, AttributeTaskStatus } from "@nexxt/contracts/catalog";
import { StatusBadge } from "@nexxt/ui";
import { attributesStatusTone, attributeTaskStatusTone } from "@nexxt/ui/status";
import { m } from "../paraglide/messages.js";
import type { AttributeTask } from "./attributes.queries";

// The two axes of a task (catalog.md §4): how far the SKUs are filled in, and where the attributes are between the
// brand, Tomorrow and Business Central. Sentences from the catalog, never enum values (design-system.md §2.2).

export const attributeTaskStatusLabel: Record<AttributeTaskStatus, () => string> = {
  open: m.attribute_task_status_open,
  in_progress: m.attribute_task_status_in_progress,
  complete: m.attribute_task_status_complete,
  overdue: m.attribute_task_status_overdue,
};

export const attributesStatusLabel: Record<AttributesStatus, () => string> = {
  draft: m.attributes_status_draft,
  pending: m.attributes_status_pending,
  sync_in_progress: m.attributes_status_sync_in_progress,
  approved: m.attributes_status_approved,
};

/**
 * Where a task stands for who follows it (ADR-309): the words of its SKUs while the attributes are a draft, then the
 * words of the attributes.
 */
export const attributeTaskStageLabel: Record<AttributeTaskStage, () => string> = {
  ...attributeTaskStatusLabel,
  pending: attributesStatusLabel.pending,
  sync_in_progress: attributesStatusLabel.sync_in_progress,
  approved: attributesStatusLabel.approved,
};

export function AttributeTaskStatusBadge({ status }: { status: AttributeTaskStatus }) {
  return <StatusBadge tone={attributeTaskStatusTone[status]} label={attributeTaskStatusLabel[status]()} />;
}

export function AttributesStatusBadge({ status }: { status: AttributesStatus }) {
  return <StatusBadge tone={attributesStatusTone[status]} label={attributesStatusLabel[status]()} />;
}

/** "62% · 31 of 50": the unlocked SKUs with every required attribute (FR-M4-04). */
export function completenessText(task: Pick<AttributeTask, "completenessPct" | "unlockedCount" | "incompleteCount">) {
  return m.attribute_task_completeness({
    pct: String(Math.floor(Number(task.completenessPct))),
    complete: task.unlockedCount - task.incompleteCount,
    unlocked: task.unlockedCount,
  });
}
